import { memo } from "react";
import BedSvg from "../../../../../public/assets/svg/property-card/BedSvg";
import BathSvg from "../../../../../public/assets/svg/property-card/BathSvg";
import SizeSvg from "../../../../../public/assets/svg/property-card/SizeSvg";
import { numCommas } from "@/utils/numCommas";

const CfdBedBathSqft = ({ item, activeTab }) => {
  const isSavedTab = activeTab === "saved";

  // Extract values based on tab type
  const totalBedCount = isSavedTab
    ? (item?.propertyDetails?.commonAttributes?.bedroomsNum ?? 0)
    : (item?.bedCount ?? 0);

  const totalBathCount = isSavedTab
    ? (item?.propertyDetails?.commonAttributes?.bathsNum ?? 0)
    : (item?.bathCount ?? 0);

  let areaSquareFeet = isSavedTab
    ? item?.propertyDetails?.commonAttributes?.areaSquareFeet
    : item?.areaSquareFeet;

  // // Format square footage with commas
  if (areaSquareFeet) {
    areaSquareFeet = areaSquareFeet.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    areaSquareFeet = Number(areaSquareFeet).toLocaleString(); // Add commas
  } else {
    areaSquareFeet = "0"; // Ensure it displays as "0 ft²"
  }

  const truncateNumber = (num) => {
    if (num && num.length > 9) {
      return num.substring(0, 9) + "...";
    }
    return num;
  };

  return (
    <div className="prop_details mb0">
      <span className="list-inline-item font-mb">
        <BedSvg />
        <a href="#" className="BBS-text">
          {numCommas(totalBedCount)} Beds
        </a>
      </span>
      <span className="list-inline-item font-mb">
        <BathSvg />
        <a href="#" className="BBS-text">
          {numCommas(totalBathCount)} Baths
        </a>
      </span>

      {areaSquareFeet && (
        <span className="list-inline-item font-mb">
          <SizeSvg />
          <a href="#" className="BBS-text">
            {truncateNumber(numCommas(areaSquareFeet))} ft<sup>2</sup>
          </a>
        </span>
      )}
    </div>
  );
};

export default memo(CfdBedBathSqft);
